/**
 * 这个文件写一些公用的请求
 */
import request from '@/utils/request'
// 上传图片
export const uploadImg = (data) => {
  return request({
    url: '/erp/tool/upload',
    method: 'post',
    data,
    isUplaod:true
  })
}


// 获取最新版本信息
export const getVersion = (data) => {
  return request({
    url: '/erp/index/version',
    method: 'get',
    data
  })
}

// 获取最新版本信息
export const getUserAuth = (data) => {
  return request({
    url: '/erp/role/info',
    method: 'post',
    data
  })
}